import { HttpStatusCode } from 'axios';

export interface ApiError {
	error: string;
	message: ErrorCode[] | string;
	status: HttpStatusCode;
}

export interface AppError {
	status: HttpStatusCode;
	stack: ErrorCode | string;
}

export enum ErrorCode {
	GENERIC = 'genericError',
	INVALID_FILE_TYPE = 'cantUploadFileType',
	USER_NOT_FOUND = 'userNotFound',
	USER_NOT_ACTIVE = 'userNotActive',
	INVALID_EMAIL = 'emailIsNotValid',
	DUPLICATED_EMAIL = 'duplicatedEmail',
	MISSING_FIELD = 'missingField',
	INVALID_PASSWORD = 'invalidPassword',
	INVALID_REFRESH_TOKEN = 'invalidRefreshToken',
	REFRESH_TOKEN_EXPIRED = 'refreshTokenExpired',
	INVALID_TOKEN = 'invalidToken',
	INVALID_HASH = 'invalidHash',
	INVALID_POSTAL_CODE = 'invalidPostalCode',
	PRODUCT_CANNOT_BE_UPDATED = 'productCannotBeUpdated',
	DUPLICATED_NAME = 'duplicatedName',
	TOO_MANY_REQUESTS = 'tooManyRequests',
	USER_NOT_AN_ADMIN = 'userNotAnAdmin',

	PASSWORD_TOO_WEAK = 'passwordTooWeak',
	DIFFERENT_PASSWORDS = 'differentPasswords',
}

const codeToMessage = (code: ErrorCode | string) => {
	switch (code) {
		case ErrorCode.GENERIC:
			return 'Coś poszło nie tak! Spróbuj ponownie później.';
		case ErrorCode.PASSWORD_TOO_WEAK:
			return 'Hasło nie spełnia wymogów bezpieczeństwa!';
		case ErrorCode.INVALID_FILE_TYPE:
			return 'Format pliku nieobsługiwany!';
		case ErrorCode.USER_NOT_FOUND:
			return 'Taki email nie istnieje w systemie.';
		case ErrorCode.INVALID_PASSWORD:
			return 'Podane hasło jest nieprawidłowe!';
		case ErrorCode.DUPLICATED_EMAIL:
			return 'Podany adres email jest już zajęty!';
		case ErrorCode.INVALID_REFRESH_TOKEN:
			return 'Nieprawidłowy token!';
		case ErrorCode.REFRESH_TOKEN_EXPIRED:
			return 'Token wygasł!';
		case ErrorCode.INVALID_TOKEN:
			return 'Podano nieprawidłowy token!';
		case ErrorCode.INVALID_HASH:
			return 'Podano nieprawidłowy token!';
		case ErrorCode.MISSING_FIELD:
			return 'Nie podano jednego z wymaganych pól!';
		case ErrorCode.DUPLICATED_NAME:
			return 'Podana nazwa jest zajęta!';
		case ErrorCode.USER_NOT_AN_ADMIN:
			return 'Użytkownik nie jest administratorem!';
		case ErrorCode.DIFFERENT_PASSWORDS:
			return 'Podane hasła są różne!';
		default:
			return '';
	}
};

export const getErrorMessage = (code: AppError['stack']) => {
	const errorMessage = codeToMessage(code[0]);
	return errorMessage || codeToMessage(ErrorCode.GENERIC);
};
